/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { Growl } from 'primereact/growl'

import ManageExchangeComponent from '../components/ManageExchangeComponent'

import { exchangeActions } from '../_actions'
import { messageConstants } from '../_constants'
import { getLoader } from '../_common/utils'

function ManageExchangeContainer({ exchangeList, getExchangeByPage, deleteExchange, totalRecords, zeroValueList,
  isGetAllError, isExchangeLoading, isExchangeZeroLoading, deleteZeroValueMessage, deletedData, deleteZeroValueCompanyByExchange, getZeroValueCompanyByExchange, clearAllMessages }) {
  const growl = useRef()
  const showShowDeleteGrowl = (message) => {
    growl.current.show({ severity: messageConstants.sevirity.success, summary: '', detail: message })
    clearAllMessages()
  }

  useEffect(() => {
    if (exchangeList.length < 1 && !isGetAllError && !isExchangeLoading) {
      getExchangeByPage(0, 20, '')
    }
    if (deletedData && deletedData.message && deletedData.message && deletedData.message === 'success') {
      showShowDeleteGrowl('Deleted Successfully')
    }
  }, [deletedData, getExchangeByPage, exchangeList, isGetAllError, isExchangeLoading, showShowDeleteGrowl])


  return (
    <div className="p-grid pageWrapper">
      {isExchangeLoading ? getLoader() : ''}
      <Growl ref={growl} />
      <ManageExchangeComponent exchangeList={exchangeList}
        getExchangeByPage={getExchangeByPage}
        totalRecords={totalRecords}
        deleteExchange={deleteExchange}
        getZeroValueCompanyByExchange={getZeroValueCompanyByExchange}
        deleteZeroValueCompanyByExchange={deleteZeroValueCompanyByExchange}
        zeroValueList={zeroValueList}
        isExchangeLoading={isExchangeLoading}
        isExchangeZeroLoading={isExchangeZeroLoading}
        deleteZeroValueMessage={deleteZeroValueMessage}
      />
    </div>
  )
}
const mapStateToProps = state => {
  return {
    exchangeList: state.exchange.exchangeList ? state.exchange.exchangeList : [],
    totalRecords: state.exchange.count,
    isGetAllError: state.exchange.isGetAllError,
    isExchangeLoading: state.exchange.isLoading,
    isExchangeZeroLoading: state.exchange.isZeroLoading,
    deletedData: state.exchange.deletedData ? state.exchange.deletedData : {},
    zeroValueList: state.exchange.zeroValueList ? state.exchange.zeroValueList : [],
    deleteZeroValueMessage: state.exchange.deleteZeroValueMessage,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getExchangeByPage: (start, pageSize, search) => dispatch(exchangeActions.getExchangeByPage(start, pageSize, search)),
    deleteExchange: (id, userId) => dispatch(exchangeActions.deleteExchange(id, userId)),
    getZeroValueCompanyByExchange: (id) => dispatch(exchangeActions.getZeroValueCompanyByExchange(id)),
    deleteZeroValueCompanyByExchange: (id) => dispatch(exchangeActions.deleteZeroValueCompanyByExchange(id)),
    clearAllMessages: () => dispatch(exchangeActions.clearAllMessages()),

  }
}
ManageExchangeContainer.propTypes = {
  exchangeList: PropTypes.array,
  getExchangeByPage: PropTypes.func,
  totalRecords: PropTypes.number,
  isGetAllError: PropTypes.bool,
  isExchangeLoading: PropTypes.bool,
  deleteExchange: PropTypes.func,
  deletedData: PropTypes.object,
  getZeroValueCompanyByExchange: PropTypes.func,
  deleteZeroValueCompanyByExchange: PropTypes.func,
  zeroValueList: PropTypes.array,
  clearAllMessages: PropTypes.func,
  deleteZeroValueMessage: PropTypes.object,
  isExchangeZeroLoading: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageExchangeContainer)
